import { render, staticRenderFns } from "./RecentActions.vue?vue&type=template&id=3d38746d&scoped=true"
import script from "./RecentActions.vue?vue&type=script&lang=ts"
export * from "./RecentActions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d38746d",
  null
  
)

export default component.exports